import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SMTPInfo from './SMTPInfo';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';


export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.smtpSetupLabel);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
  if (!restrictUrls('/siteadmin/smtp-info', adminPrivileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><SMTPInfo title={title} /></AdminLayout>,
  };
}
